<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h2 class="title_page">회원 로그인</h2>

            <div class="login_box_area">
                <!-- <h3 class="title_login">
                    Hi-Vitamin<br>Membership
                </h3> -->

                <div class="login_input_area">
                    <ul class="login_menu_list">
                        <li>
                            <RouterLink to="/HFO_LO_002">아이디 찾기</RouterLink>
                        </li>
                        <li class="on">
                            <RouterLink to="/HFO_LO_005">비밀번호 찾기</RouterLink>
                        </li>
                    </ul>

                    <ul class="login_input_list">
                        <li>
                            <h3 class="title_input">아이디</h3>

                            <InputText id="memberId" :placeholder="placeholderID" />

                            <!-- <p class="required">이메일 형식이 맞지 않습니다. 다시 입력해주세요</p> -->
                        </li>
                        <li>
                            <h3 class="title_input">이메일</h3>

                            <InputText id="email" :placeholder="placeholderPhone" />

                            <!-- <p class="required">‘-’ 하이픈 없이 숫자만 입력해주세요.</p> -->
                        </li>
                    </ul>

                    <div class="btn_login_area">
                        <button class="btn_type2" @click="getPwd">확인</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlertPopup v-model="alertRequiredShow" :title="alertTitle">
        <template #layer_content>
            <p class="alert_txt" id="alert_txt">
                {{ alertContent }}
            </p>
        </template>
    </AlertPopup>
</template>

<script>
import InputText from '@/components/InputText'
import { postAxios } from '@/lib/AxiosCall';
import router from '@/router';
import { useRouter } from "vue-router";
import AlertPopup from '@/components/AlertPopup.vue';

export default {
    components: {
        InputText,
        AlertPopup
    },
    data() {
        return {
            placeholderID: '가입 할때 등록한 아이디를 입력해주세요.',
            placeholderPhone: '가입 할때 등록한 이메일을 입력해주세요.',
            alertRequiredShow: false
        }
    },
    setup() {
        const router = useRouter();
    },
    methods: {
        async getPwd() {
            const response = await postAxios('/bgm/v1/mem/search/pwd', {
                "id": document.querySelector("#memberId").value,
                "email": document.querySelector("#email").value,
                "authType": "email"
            });

            if (response.message != null) {
                this.alertTitle = '알림'
                this.alertContent = '아이디 또는 이메일 오류 입니다.'
                this.alertRequiredShow = true;
            } else {
                this.alertTitle = '알림'
                this.alertContent = '이메일로 비밀번호가 전송 되었습니다.'
                this.alertRequiredShow = true;
            }

        }
    }
}
</script>